// extracted by mini-css-extract-plugin
export default {"myPopoverVertical":"toogle_myPopoverVertical__eoXmq"};